import { SUPPORTED_CHAIN_IDS } from '../config/config.types';

export const getChainIdFromUrl = (): string => {
  const path = window.location.pathname;
  const regex = /\/(?:stream|room)\/(\d+)\/(\d+)(?:\/|$)/;

  const match = regex.exec(path);
  if (!match) return '';

  const chainId = parseInt(match[1], 10);
  const supportedValues = Object.values(SUPPORTED_CHAIN_IDS);

  return supportedValues.includes(chainId) ? String(chainId) : '';
};
